import { render, staticRenderFns } from "./TournamentModeration.vue?vue&type=template&id=3c4fb298&lang=pug"
import script from "./TournamentModeration.vue?vue&type=script&lang=js"
export * from "./TournamentModeration.vue?vue&type=script&lang=js"
import style0 from "./TournamentModeration.vue?vue&type=style&index=0&id=3c4fb298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports